import { useMemo } from 'react'
import { useChannelPreviewInfo } from 'stream-chat-react'
import { ChatChannelInstance, isChatGroup, useChatDMUser, useChatUserImage } from '@packages/chat'

type UseChatPreviewAvatarProps = {
  channel: ChatChannelInstance
}

export const useChatPreviewAvatar = ({ channel: channelProps = {} as ChatChannelInstance }: UseChatPreviewAvatarProps) => {
  // To store the first channel value and avoid crashes if channel changes to null
  const channel = useMemo(() => channelProps as ChatChannelInstance, [])
  const isGroup = isChatGroup(channel)
  const { dmUser } = useChatDMUser(channel)
  const dmUserId = dmUser?.user_id
  const { displayImage } = useChannelPreviewInfo({ channel })
  const dmUserImage = useChatUserImage(dmUserId, displayImage ?? null)

  return useMemo(() => {
    if (isGroup) return (channel?.data as any)?.image ?? null

    return dmUserImage
  }, [isGroup, (channel?.data as any)?.image, dmUserImage])
}
